import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IBranding } from '../../../../models/user';

@Injectable({ providedIn: 'root' })
export class BrandingStateManagerService {
    private _brandingSubject = new BehaviorSubject<IBranding>(null);
    public branding$ = this._brandingSubject.asObservable();
    constructor() {}

    public setBrandingSubject(branding: IBranding): void {
        this._brandingSubject.next(branding);
    }
}
